
let equipmentOutdoorItems = [
    { id: 1, name: 'Barbecue',  alt:"Icône Barbecue", imageSrc: './assets/equipement/barbecue.svg' },
    { id: 2, name: 'Parking privé', alt:"Icône Parking privé", imageSrc: './assets/equipement/park.svg' },
    { id: 3, name: 'Jardin partagé',alt:"Icône Jardin partagé", imageSrc: './assets/equipement/garde.svg' },
    { id: 4, name: 'Chaises transats', alt:"Icône Chaise transat",  imageSrc: './assets/equipement/deck_chair.svg' },
    { id: 5, name: 'Salon de jardin', alt:"Icône Salon de jardin", imageSrc: './assets/equipement/garden.svg' },
    { id: 6, name: 'Terrasse privée', alt: "Icône Terrasse privée",  imageSrc: './assets/equipement/privat.svg' }
  ];
    
  export { equipmentOutdoorItems };  // Exportation nommée
  export default equipmentOutdoorItems;  // Exportation par défaut

